interface AlertOptions {
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
  onConfirm?: () => void
  onCancel?: () => void
}

export const useAlert = () => {
  const isShow = ref(false)
  const title = ref('')
  const message = ref('')
  const confirmText = ref('확인')
  const cancelText = ref('')
  const onConfirmCallback = ref<(() => void) | null>(null)
  const onCancelCallback = ref<(() => void) | null>(null)

  const show = (options: AlertOptions) => {
    title.value = options.title || '알림'
    message.value = options.message
    confirmText.value = options.confirmText || '확인'
    cancelText.value = options.cancelText || ''
    onConfirmCallback.value = options.onConfirm || null
    onCancelCallback.value = options.onCancel || null
    isShow.value = true
  }

  const hide = () => {
    isShow.value = false
    confirmText.value = '확인'
    cancelText.value = ''
    onConfirmCallback.value = null
    onCancelCallback.value = null
  }

  const confirm = () => {
    if (onConfirmCallback.value) {
      onConfirmCallback.value()
    }
    hide()
  }

  const cancel = () => {
    if (onCancelCallback.value) {
      onCancelCallback.value()
    }
    hide()
  }

  return {
    isShow,
    title,
    message,
    confirmText,
    cancelText,
    show,
    hide,
    confirm,
    cancel
  }
}

// 전역 상태를 위한 공유 인스턴스
export const Alert = reactive({
  ...useAlert()
})